import Chart, { ChartDataSets } from "chart.js";
import moment from "moment";
import SeatMapping from "../seatMapping";
import { MstSignallampSettingType, SeatSensorData, seatDataSetsType } from "../../../types/types";

const colors: { [key: string]: any } = {
  red: "rgba(160, 20, 20, 1)",
  yellow: "rgba(255, 255, 0, 1)",
  green: "rgba(71, 142, 51, 1)",
  blue: "rgba(18, 65, 145, 1)",
  white: "rgba(255, 255, 255, 1)",
  noSignal: "rgba(255, 255, 255, 0)",
};

/**
 * 色の判定
 * @param pir_status
 */
function checkColor(pir_status: number): string {
  // 色設定 1なら青 0なら赤
  let color = colors.red;
  if (pir_status === 1) {
    color = colors.blue;
  }
  return color;
}

export function makeListDataSets(
  historyData: SeatSensorData[],
  self: SeatMapping
) {
  const datasets: seatDataSetsType[] = [];
  // 最新1件以外をforで加工
  if (historyData) {
    let num = 1;
    for (let i = 0; i < historyData.length - 1; i++) {
      const targetHistory = historyData[i];
      const duration = targetHistory.duration;
      // 色設定 1なら青 0なら赤
      let color = colors.red;
      if (targetHistory.pir_status === 1) {
        color = colors.blue;
      }
      console.log("color", color);
      datasets.push({
        id: num,
        timeStamp: moment(targetHistory.time_stamp).utcOffset(self.timeZone).format("YYYY-MM-DD HH:mm:ss"),
        deviceId: targetHistory.device_id,
        duration: Number(moment(duration)),
        color: color.blue,
      });
      num++;
    }
    // 以下最新1件の加工処理
    const latestHistory = historyData[historyData.length - 1];
    const latestColor = checkColor(
      latestHistory.pir_status
    );
    datasets.push({
      id: 0,
      timeStamp: moment(latestHistory.time_stamp).utcOffset(self.timeZone).format("YYYY-MM-DD HH:mm:ss"),
      deviceId: latestHistory.device_id,
      duration: "--",
      color: colors[latestColor],
    });
    return datasets.reverse();
  }
  return datasets;
}

/**
 * chart用datasetsの生成
 * @param mst_signallamp
 * @param historyData
 * @param toTime
 * @param fromTime
 */
function makeChartDataSets(
  historyData: any,
  toTime: string,
  fromTime: string
): ChartDataSets[] {
  const datasets = [];
  const nowTime = moment(toTime).format("X");
  const lastTime = moment(fromTime).format("X");
  let lampColor: string = "noSignal";
  if (historyData) {
    if (historyData.length > 1) {
      const lastHistory = historyData[0];
      const lastLampColor = checkColor(lastHistory.pir_status);
      const secondHistoryTime = moment(historyData[1].time_stamp).format("X");
      datasets.push({
        data: [Number(Number(secondHistoryTime) - Number(lastTime))],
        backgroundColor: colors[lastLampColor],
      });

      for (let i = 1; i < historyData.length - 1; i++) {
        const targetHistory = historyData[i];
        const duration =
          Number(moment(historyData[i + 1].time_stamp).format("X")) -
          Number(moment(targetHistory.time_stamp).format("X"));
        lampColor = checkColor(lastHistory.pir_status);
        datasets.push({
          data: [Number(duration)],
          backgroundColor: colors[lampColor],
        });
      }

      const latestHistory = historyData[historyData.length - 1];
      const latestLampColor = checkColor(lastHistory.pir_status);
      const latestTime = moment(latestHistory.time_stamp).format("X");
      datasets.push({
        data: [Number(nowTime) - Number(latestTime)],
        backgroundColor: colors[latestLampColor],
      });
    } else if (historyData.length === 1) {
      const useColor = checkColor(historyData.pir_status);
      const latestTime = moment(historyData[0].time_stamp).format("X");
      datasets.push({
        data: [Number(nowTime) - Number(latestTime)],
        backgroundColor: colors[useColor],
      });
    }
  }
  return datasets;
}

/**
 * 8時間分のグラフを描画する
 * @param self
 * @param historyData
 * @param toTime
 * @param fromTime
 */
export function chartHistoryGraph(
  historyData: any,
  toTime: string,
  fromTime: string
) {
  const canvas = document.getElementById("horizontalBar") as HTMLCanvasElement;
  return new Chart(canvas.getContext("2d"), {
    type: "horizontalBar",
    data: {
      datasets: makeChartDataSets(
        historyData,
        toTime,
        fromTime
      ),
    },
    options: {
      legend: {
        display: false,
      },
      scales: {
        xAxes: [
          {
            stacked: true,
            ticks: {
              display: false,
            },
            gridLines: {
              display: false,
            },
          },
        ],
        yAxes: [
          {
            stacked: true,
          },
        ],
      },
      tooltips: {
        enabled: false,
      },
    },
  });
}
